module.exports = __webpack_public_path__ + "img/help-ot2.32bb5e6e.png";